import type { ApiClient } from './runtime/apiRuntime';
import { EmailTemplateType } from './Api';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const EmailTemplateApi = {
    get: (data: { templateType: EmailTemplateType; language: string; subTemplate?: string }, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['emailTemplate', 'get', data.templateType, data.language, data.subTemplate || ''], (api) => api.emailTemplate.get(data), options),
    set: (options?: BaseApiMutationOptions<ApiClient['emailTemplate']['set']>) => apiMutationOptions((api) => api.emailTemplate.set, options),
    preview: (options?: BaseApiMutationOptions<ApiClient['emailTemplate']['preview']>) => apiMutationOptions((api) => api.emailTemplate.preview, options),
    getCalendarAttachment: (data: { templateType: EmailTemplateType; subTemplate?: string }, options?: BaseApiQueryOptions) =>
        apiQueryOptions(
            ['emailTemplate', 'getCalendarAttachment', data.templateType, data.subTemplate || ''],
            (api) => api.emailTemplate.getCalendarAttachment(data),
            options
        ),
    setCalendarAttachment: (options?: BaseApiMutationOptions<ApiClient['emailTemplate']['setCalendarAttachment']>) =>
        apiMutationOptions((api) => api.emailTemplate.setCalendarAttachment, options)
};
